import Pagination, { PaginationProps, PAGINATION_TYPES } from './Pagination'

export default Pagination

export { Pagination, PAGINATION_TYPES }
export type { PaginationProps }
